import { BaseGetRequest } from './core/baseGetRequest';
import { Authentication } from './core/baseRequest';
import { LoyaltyTransactionsList, LoyaltyTransactionsListDynamicType } from '../models/loyaltyTransactionsList';

export class TransactionHistoryRequest extends BaseGetRequest<LoyaltyTransactionsList> {
    constructor() {
        super(
            `loyalty/transaction-history`,
            {},
            LoyaltyTransactionsListDynamicType,
            Authentication.Login
        );
    }
}
